module.exports = __webpack_public_path__ + "img/zhxygn.f17a6354.jpg";